import { Button, Image, Link } from '@heroui/react';
import { useTranslation } from 'react-i18next';

import ErrorImage from '@/assets/images/error.png';

const mailto =
  'mailto:support@seamless.md?subject=SeamlessMD%20Support%20request%20-%20Crash%20Report&body=Please%20include%20the%20following%20information%3A%0A%0APatient%20Name%3A%0AHospital%20Name%3A%0AEmail%3A%0APhone%20number%3A';

export function Crash() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center">
      <Image src={ErrorImage} width={800} disableSkeleton />
      <h1 className="text-xl mb-4">{t('common.layout.crash')}</h1>
      <Button
        as={Link}
        href={mailto}
        isExternal
        color="primary"
        size="sm"
        variant="flat"
      >
        {t('common.link.help')}
      </Button>
    </div>
  );
}
